export const selectCompanyName = (state) =>
  state?.orgs?.current?.companyName ?? "";

export const selectOrganizationCreationDate = (state) =>
  state?.orgs?.current?.creationDate ?? null;

export const selectLogoUrl = (state) => state?.orgs?.current?.logoUrl ?? "";

export const selectOrgs = (state) => state?.orgs?.list ?? [];
export const selectOrgsLoading = (state) => state?.orgs?.loading ?? false;
export const selectOrgsError = (state) =>
  state?.orgs?.errors?.fetchUserOrganizations ?? null;

export const selectOwnerName = (state) => {
  return `${state?.orgs?.current?.ownerFirstName} ${state?.orgs?.current?.ownerLastName}`;
};

export const selectAmainvoiceLink = (state) =>
  state?.orgs?.current?.links?.amainvoiceLink ?? null;
export const selectBillbeeLink = (state) =>
  state?.orgs?.current?.links?.billbeeLink ?? null;
export const selectReplycoLink = (state) =>
  state?.orgs?.current?.links?.replycoLink ?? null;
export const selectVentoryOneLink = (state) =>
  state?.orgs?.current?.links?.ventoryOneLink ?? null;
